import { render, staticRenderFns } from "./EditarTicket.vue?vue&type=template&id=007167fd"
import script from "./EditarTicket.vue?vue&type=script&lang=js"
export * from "./EditarTicket.vue?vue&type=script&lang=js"
import style0 from "./EditarTicket.vue?vue&type=style&index=0&id=007167fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports